/* Contara: ctr-article (CNV-6396) — TOC active link, smooth in-page scrolling, scroll reveal. */
(function () {
  'use strict';

  if (window.CtrArticle) return;

  var instances = {};
  var reducedQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function prefersReduced() {
    return reducedQuery.matches;
  }

  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  /* ---------- Scroll reveal (per section) ---------- */
  function initReveal(root) {
    if (!root.hasAttribute('data-ctr-article-reveal')) return null;
    if (prefersReduced() || isDesignMode() || !('IntersectionObserver' in window)) return null;

    var targets = root.querySelectorAll('[data-ctr-reveal]');
    if (!targets.length) return null;

    root.setAttribute('data-ctr-animate', 'true');
    var timers = [];

    var io = new IntersectionObserver(
      function (entries, observer) {
        var batch = 0;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          observer.unobserve(el);
          timers.push(
            setTimeout(function () {
              el.classList.add('is-revealed');
            }, batch * 75)
          );
          batch += 1;
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    targets.forEach(function (el) {
      io.observe(el);
    });

    return function destroy() {
      io.disconnect();
      timers.forEach(clearTimeout);
      root.removeAttribute('data-ctr-animate');
    };
  }

  /* ---------- TOC active state (per section with a TOC) ---------- */
  function setActive(id) {
    var links = document.querySelectorAll('[data-ctr-article-toc] a, a.ctr-article__toc-link');
    links.forEach(function (link) {
      var on = link.getAttribute('href') === '#' + id;
      link.classList.toggle('is-active', on);
      if (on) {
        link.setAttribute('aria-current', 'location');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  function initToc(root) {
    var toc = root.querySelector('[data-ctr-article-toc]');
    if (!toc || !('IntersectionObserver' in window)) return null;

    var targets = [];
    toc.querySelectorAll('a[href^="#"]').forEach(function (link) {
      var id = decodeURIComponent(link.getAttribute('href').slice(1));
      var el = id && document.getElementById(id);
      if (el) targets.push(el);
    });
    if (!targets.length) return null;

    // Active = last target whose top has passed 40% of the viewport (first one before that).
    var ticking = false;
    function update() {
      ticking = false;
      var line = window.innerHeight * 0.4;
      var current = targets[0];
      targets.forEach(function (el) {
        if (el.getBoundingClientRect().top <= line) current = el;
      });
      setActive(current.id);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();

    return function destroy() {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }

  /* ---------- Smooth in-page scrolling (one document listener) ---------- */
  function onDocClick(e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target.closest && e.target.closest('a[href^="#"]');
    if (!link) return;
    var hash = link.getAttribute('href');
    if (hash.length < 2) return;
    var target;
    try {
      target = document.getElementById(decodeURIComponent(hash.slice(1)));
    } catch (err) {
      return;
    }
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: prefersReduced() ? 'auto' : 'smooth', block: 'start' });
    if (history.pushState) history.pushState(null, '', hash);
    if (!target.hasAttribute('tabindex') && !/^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test(target.tagName)) {
      target.setAttribute('tabindex', '-1');
    }
    target.focus({ preventScroll: true });
  }

  /* ---------- Lifecycle ---------- */
  function init(root) {
    var id = root.getAttribute('data-section-id');
    if (!id) return;
    destroy(id);
    instances[id] = [initReveal(root), initToc(root)];
  }

  function destroy(id) {
    var fns = instances[id];
    if (!fns) return;
    fns.forEach(function (fn) {
      if (fn) fn();
    });
    delete instances[id];
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-ctr-article]').forEach(init);
  }

  document.addEventListener('click', onDocClick);

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (e.detail && e.detail.sectionId) destroy(e.detail.sectionId);
  });

  window.CtrArticle = { init: init, destroy: destroy, initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }
})();
